module.exports = __webpack_public_path__ + "img/alta_gastronomia.b3ee0cab.png";